import React, {useContext} from "react";
import {UserContext} from "@web/hooks/context";
// import LineReservationManager from "@web/components/LineReservationManager";
import {Redirect} from "wouter";
import {useSelector} from "react-redux";
import useDocumentFirestore from "@web/hooks/useDocumentFirestore";

const WithLineOnboarding = (props) => {
  const [userId, h, u, claims] = useContext(UserContext);
  const assistantPath = ["user", userId, "lines", "assistant"].join("/");
  const [assistantLine, loadingAssistant] = useDocumentFirestore(userId && assistantPath);
  const assistantName = useSelector((state) => state.Lines.data?.[assistantPath]?.assistantName);
  // console.log("WithLineOnboarding", {assistantLine, loadingAssistant});

  if (!userId) {
    return null;
  }
  if (!claims?.data) {
    return null;
  }
  if (loadingAssistant) {
    return null;
  }

  return (assistantLine?.assistantName || assistantName) ?
    props.children :
    <Redirect to="/start" />;
}

export default WithLineOnboarding
